import React from 'react';
import classNames from 'classnames';
import { Image, NackleTileTripleInfinity, NackleTileDoubleInfinity, Typography } from '../../exports';

const NackleTile = ( { doubleWide = false, ...props } ) => {
    if ( doubleWide ) {
        return <NackleTileDoubleInfinity { ...props } />;
    }

    return <NackleTileTripleInfinity { ...props } />;
};

/**
 * A component that renders a program tile with image, title, description and optional extra content
 * @module NackleProgramTile
 * @param {Object} props - The component props
 * @param {string} [props.className] - Additional CSS class name
 * @param {Function} [props.onClick] - Click handler function
 * @param {string} [props.imgSrc] - Source URL for the program image
 * @param {string} [props.imgAlt] - Alt text for the program image
 * @param {string} [props.title] - Title text for the program
 * @param {string} [props.description] - Description text for the program
 * @param {boolean} [props.doubleWide] - Whether the tile should be a NackleTileDouble or Triple Infinity width
 * @param {React.ReactNode} [props.extra] - Optional extra content to render
 * @returns {React.ReactElement} A program tile component
 */

const NackleProgramTile = ( { className, onClick, imgSrc, imgAlt, title, description, extra, doubleWide } ) => {

    const tileClasses = classNames( {
        'nackle-program-tile': true,
        [ className ]: className ? true : false
    } );

    const { Title } = Typography;

    return (
        <NackleTile doubleWide={ doubleWide } className={ tileClasses } onClick={ onClick }>
            <div className='content-wrapper'>
                <Image
                    className="program-hero"
                    src={ imgSrc }
                    alt={ imgAlt }
                    preview={ false }
                />
                <div className="program-info">
                    <div className="program-title-description">
                        <Title className="title" level={ 2 }>{ title }</Title>
                        <Title className="description" level={ 4 }>{ description }</Title>
                    </div>
                    {
                        extra &&
                        <div className="extra">
                            { extra }
                        </div>
                    }
                </div>
            </div>
        </NackleTile>
    );
};

export { NackleProgramTile };
